import React, { FC, memo, MouseEvent, useLayoutEffect } from 'react'

import { useParams } from 'react-router'

import { definitions } from 'api/generated/photo'
import { ModerationStatus } from 'api/photo/photo.types'
import { slicedPhotos } from 'components/page/PhotoViewer/function/slicedPhotos'
import { PhotoViewerParams } from 'components/page/PhotoViewer/PhotoViewer.paths'
import {
  Image,
  PhotoWrapper,
  Picture,
  Source,
} from 'components/page/PhotoViewer/PhotoViewer.styled'
import { translateX } from 'functions/layout/translate'
import { useIsCurrentUser } from 'hooks/useIsCurrentUser'

import { carouselDomId } from '../PhotoViewerCarousel/PhotoViewerCarousel.constants'
import { PhotoViewerPromoCase } from '../PhotoViewerCarousel/PhotoViewerCarousel.types'

export const PhotoViewerPhotosWrapper: FC<{
  photos: definitions['OmniAlbumPhoto'][]
  currentIndex: number
  /**
   * Вызывает сдвиг карусели, если менялись только промки.
   * Сами фотки те же, т.к. только одна.
   */
  promoCase: null | boolean | PhotoViewerPromoCase
  isShowNotice: boolean
  onPhotoClick?: (event: MouseEvent<HTMLDivElement>) => void
}> = memo(({ photos, currentIndex, promoCase, isShowNotice, onPhotoClick }) => {
  const { userId } = useParams<PhotoViewerParams>()
  const isCurrentUser = useIsCurrentUser(userId)

  const hasOnePhoto = photos.length === 1
  const selectedPhotoIndex = currentIndex // findCurrentIndex(photos, photoId)
  const hasOnePhotoForCurrentUser = !isShowNotice && hasOnePhoto

  useLayoutEffect(() => {
    /**
     * Сбрасывать нужно именно в момент рендера Реактом.
     * Т.к. иначе будет промежуточный пейнт и мелькание.
     */
    translateX(document.getElementById(carouselDomId)!, 0)
  }, [currentIndex, promoCase])

  /**
   * TODO:
   * если вдруг мы смотрим чужие фото, и фото одно, то нужно обязательно вернуть slidedPhotos.
   * Тогда notice после последнего фото будет работать правильно
   *
   * Для просмотра своего фото и приаттаченных фото к сообщению,
   * не нужно показывать notice. Поэтому проверяем на isPhotoWithNotice и что фото одно.
   */

  const photosSwipe: definitions['OmniAlbumPhoto'][] = hasOnePhotoForCurrentUser
    ? photos
    : slicedPhotos(photos, selectedPhotoIndex)

  // console.log('PhotoViewerPhotosWrapper', { photosSwipe })

  return (
    <>
      {photosSwipe.map(
        (
          { photoId, urls: { huge, xHuge }, pending, moderationStatus },
          index
        ) => {
          return (
            <PhotoWrapper
              /**
               * Если фоток 2, то получается вторая фотка и слева и справа от первой.
               * А если одна фотка, то вообще все одинаковые.
               */
              key={`${index}-${huge}`}
              $isShadowUpperPhoto={
                isCurrentUser &&
                (pending || moderationStatus !== ModerationStatus.approved)
              }
              data-name={`photos-${photoId}`}
              onClick={onPhotoClick}
            >
              <Picture>
                {xHuge && <Source srcSet={xHuge} type="image/webp" />}
                <Image src={huge} />
              </Picture>
            </PhotoWrapper>
          )
        }
      )}
    </>
  )
})
